import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { permissionTypes } from 'drapcode-constant';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { checkCodeExportPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class BetaCodeExport extends Component {
  static propTypes = {
    deploymentSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  // upgradeAccountEmail = () => {
  //   const { actions, match } = this.props;
  //   const { projectId } = match.params;
  //   actions.requestUpgradeAccount({ projectId, code: permissionTypes.CODE_EXPORT });
  // };

  render() {
    const isAllowed = checkCodeExportPermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Code Export" />
        </CommonPageComponent>
      );
    }
    return (
      <CommonPageComponent>
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="card">
            <div className="card-header card-header-icon" data-background-color="drapcode-violet">
              <i className={`wb ${drapcodeIcon('codeExport')}`}></i>
            </div>
            <div className="card-content">
              <div className="card-title-header">
                <h4 className="card-title">Code Export (Beta)</h4>
                <div className="card-cta"></div>
              </div>
              <strong>
                This feature is in Beta, we are still making it perfect. Please reach out to us if
                there are any questions.
              </strong>
              &nbsp;
            </div>
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    deploymentSetting: state.deploymentSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BetaCodeExport);
